import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { formatTimeInStatus } from '@app/pages/admin/orchestration-data-records.util';

@Component({
  selector: 'app-live-status-duration',
  standalone: true,
  templateUrl: './live-status-duration.html',
  styleUrl: './live-status-duration.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveStatusDurationComponent {
  readonly changedAt = input<string | null | undefined>(null);
  readonly until = input<string | null | undefined>(null);
  readonly live = input(false);
  readonly duration = signal<string | null>(null);

  constructor() {
    effect((onCleanup) => {
      const changedAt = this.changedAt();
      const until = this.until();
      const live = this.live() && !until;
      this.duration.set(formatTimeInStatus(changedAt, Date.now(), until));
      if (!live || !changedAt) {
        return;
      }
      const timer = setInterval(() => {
        this.duration.set(formatTimeInStatus(this.changedAt(), Date.now(), this.until()));
      }, 1000);
      onCleanup(() => clearInterval(timer));
    });
  }
}
